import dayjs from 'dayjs';


// ES6 module syntax
import en from './strings/en';

// eslint-disable-next-line import/no-mutable-exports
let strings,
    language;

const detectDeviceLocale = () => {
  try {
    language = window.navigator.languages && window.navigator.languages.length > 0
      ? window.navigator.languages[0]
      : window.navigator.language || window.navigator.userLanguage;

    // dayjs.locale(language);

    const firstPart = language.split(/-|_/g)[0];
    // eslint-disable-next-line global-require, import/no-dynamic-require
    strings = require(`./strings/${firstPart}`).default;
  } catch (e) {
    strings = en;
    language = 'en';
  }
  return language;
};
detectDeviceLocale();

export const detectDeviceClockFormat = (locale = detectDeviceLocale()) => {
  const timeString = new Date().toLocaleTimeString(locale),
        foundAMorPM = timeString.indexOf('AM') > -1 || timeString.indexOf('PM') > -1;

  return foundAMorPM ? '12' : '24';
};


export const languageCode = language.split(/-|_/g)[0];

export const clockFormat = detectDeviceClockFormat();

export const timeString = clockFormat === '24' ? 'H:mm' : 'h:mm A';

export default strings;
